import { Breadcrumb, Button, Card, DatePicker, Empty, Form, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { amountFormat } from "../../../../services/common.service";
import AccountService from "../../../../services/accounts.service";
import moment from "moment";
import { modeSelector } from "../../../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";

export default function ScheduleInquiry() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [accountDetails, setAccountDetails] = useState({});
  const [disbursementDetails, setDisbursementDetails] = useState([]);
  const mode = useSelector(modeSelector);
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (location.pathname === "/accounts/loan/schedule-inquiry") {
      setActiveKey("SCHEDULE_INQUIRY");
    }
    if (location.state) {
      setAccountDetails(location.state);
    }
  }, []);

  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "ACCOUNT_DETAILS") {
      navigate("/accounts/loan/summary", { state: accountDetails });
    }
    if (key === "DETAILED_STATEMENT") {
      navigate("/accounts/loan/statement", {
        state: accountDetails,
      });
    }
    if (key === "DISBURSEMENT_INQUIRY") {
      navigate("/accounts/loan/disbursement-inquiry", {
        state: accountDetails,
      });
    }
    if (key === "REPAYMENT") {
      navigate("/accounts/loan/repayment", {
        state: accountDetails,
      });
    }
  };

  const loanscheduleinq = useCallback(
    async (values) => {
      try {
        let fromDate = "";
        let toDate = "";
        if (values.dateRange !== undefined) {
          fromDate = values.dateRange[0].format("YYYY-MM-DD");
          toDate = values.dateRange[1].format("YYYY-MM-DD");
        }

        const reqparams = {
          accountNo: accountDetails?.accountNo,
          branchId: accountDetails?.branchId,
          fromDate: fromDate,
          toDate: toDate,
        };
        const response = await AccountService.loanscheduleinq(reqparams);
        if (response.status === 200) {
          setDisbursementDetails(response.data["loanScheduleDetails"]);
        }
      } catch (error) {}
    },
    [accountDetails]
  );

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {" "}
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.loans.schedule_inquiry", {
                defaultValue: "Schedule Inquiry",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.loans.schedule_inquiry", {
                defaultValue: "Schedule Inquiry",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.loan_and_finance_details", {
              defaultValue: "Investment and Finance Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.view_stmt_btn", {
              defaultValue: "View Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          {["I", "AA"].indexOf(mode) > -1 && (
            <Tabs.TabPane
              tab={t("pages.my_accounts.loans.repayment", {
                defaultValue: "Repayment",
              })}
              key="REPAYMENT"
            ></Tabs.TabPane>
          )}
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.disbursement_inquiry", {
              defaultValue: "Disbursement Inquiry",
            })}
            key="DISBURSEMENT_INQUIRY"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.schedule_inquiry", {
              defaultValue: "Schedule Inquiry",
            })}
            key="SCHEDULE_INQUIRY"
          ></Tabs.TabPane>
        </Tabs>
      </Card>
      <Card className="application-card">
        <Form layout="inline" onFinish={loanscheduleinq}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
              <Form.Item label="" name="dateRange">
                <DatePicker.RangePicker
                  // disabledDate={(current) => current.isAfter(moment())}
                  format={"DD-MM-YYYY"}
                  size="large"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <Button type="primary" htmlType="submit" size="large">
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </Card>

      
        {" "}
        {disbursementDetails.length === 0 ? (
          <Empty
            description={t("common.no_data_found", {
              defaultValue: "No data found",
            })}
            className="mt-2"
          />
        ) : (
          <>
            {showGridAccount === "GRID" && (
              <div className="ft-table mt-2">
                <table className="table">
                  <thead style={{ backgroundColor: "#F1F1F1" }}>
                    <tr>
                      <th>
                        {t("pages.pending_approval.schedule_date", {
                          defaultValue: "Schedule Date",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.loans.principal_amount", {
                          defaultValue: "Principal Amount",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.deposits.interest_amount", {
                          defaultValue: "Interest Amount",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.loans.principal_amount_paid", {
                          defaultValue: "Principal Amount Paid",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.loans.interest_amount_paid", {
                          defaultValue: "Interest Amount Paid",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.loans.principal_amount_due", {
                          defaultValue: "Principal Amount Due",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.loans.interest_amount_due", {
                          defaultValue: "Interest Amount Due",
                        })}
                      </th>
                      <th>
                        {t("pages.my_accounts.loans.total_installment", {
                          defaultValue: "Total Installment",
                        })}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {disbursementDetails.map((option, idx) => (
                      <tr key={idx}>
                        <td>{option?.scheduleDate}</td>
                        <td>{amountFormat(option?.principalAmt || "0")}</td>
                        <td>{amountFormat(option?.intrest || "0")}</td>
                        <td>{amountFormat(option?.principalPD || "0")}</td>
                        <td>{amountFormat(option?.mainIntPd || "0")}</td>
                        <td>{amountFormat(option?.principalDue || "0")}</td>
                        <td>{amountFormat(option?.mainIntDue || "0")}</td>
                        <td>
                          {amountFormat(
                            option?.principalAmt + option?.intrest || "0"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {showGridAccount === "LIST" &&
              disbursementDetails.map((option, idx) => (
                <div key={idx}>
                  <div className="account-row-data list-row mb-2 mt-2">
                    <div>
                      <div>{option?.scheduleDate}</div>
                      <div>
                        <label>
                          {t("pages.my_accounts.loans.interest", {
                            defaultValue: "Interest",
                          })}{" "}
                          -
                        </label>
                        <span>{amountFormat(option?.intrest || "0")}</span>
                      </div>
                    </div>
                    <div align="right">
                      <div>
                        {t("pages.my_accounts.loans.principal_amount", {
                          defaultValue: "Principal Amount",
                        })}
                      </div>
                      <div>{amountFormat(option?.principalAmt || "0")}</div>
                    </div>
                  </div>
                </div>
              ))}
          </>
        )}

    </>
  );
}
